import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CustomerGroupApi, FindOptions } from 'api';
import { CheckDuplicateCustomerCodeQuery } from 'api/customer';

export const filterCustomerGroup = createAsyncThunk(
  'customerGroup/filterCustomerGroup',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const selectCustomerGroup = createAsyncThunk(
  'customerGroup/selectCustomerGroup',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupApi.select(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneCustomerGroup = createAsyncThunk(
  'customerGroup/findOneCustomerGroup',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await CustomerGroupApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerInGroup = createAsyncThunk(
  'customerGroup/findCustomerInGroup',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, ...option } = params;
      const response = await CustomerGroupApi.findCustomerInGroup(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerAddInGroup = createAsyncThunk(
  'customerGroup/findCustomerAddInGroup',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await CustomerGroupApi.findCustomerAddInGroup(
        id,
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerGroupForUpdate = createAsyncThunk(
  'customerGroup/findCustomerGroupForUpdate',
  async (param: any, { rejectWithValue }) => {
    try {
      const { id, ...option } = param;
      const response = await CustomerGroupApi.filterCustomerGroupForUpdate(
        id,
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityCustomerGroup = createAsyncThunk(
  'customerGroup/createEntityCustomerGroup',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomerGroup = createAsyncThunk(
  'customerGroup/updateCustomerGroup',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerGroupApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const addCustomerInGroup = createAsyncThunk(
  'customerGroup/addCustomerInGroup',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerGroupApi.addCustomerInGroup(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const addMultiCustomerGroupForCustomer = createAsyncThunk(
  'customerGroup/addMultiCustomerGroupForCustomer',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerGroupApi.addMultiCustomerGroupForCustomer(
        id,
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCustomerInGroup = createAsyncThunk(
  'customerGroup/deleteCustomerInGroup',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerGroupApi.deleteCustomerInGroup(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomerGroupStatus = createAsyncThunk(
  'customerGroup/updateCustomerGroupStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerGroupApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCustomerGroup = createAsyncThunk(
  'customerGroup/deleteCustomerGroup',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateCustomerGroupCode = createAsyncThunk(
  'customerGroup/generateCustomerGroupCode',
  async (q_, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupApi.generateCode();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateCustomerGroupCode = createAsyncThunk(
  'customerGroup/checkDuplicateCustomerGroupCode',
  async (query: CheckDuplicateCustomerCodeQuery, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  savedList: Array<any>;
  isLoaded: boolean;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
  isLoaded: false,
};

const entityCustomerGroupSlice = createSlice({
  name: 'customerGroup',
  initialState,
  reducers: {
    reloadEntityCustomerGroup(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityCustomerGroup(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityCustomerGroup(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(selectCustomerGroup.fulfilled, (state, action) => {
      const { data } = action.payload;

      const formatData = data.map(item => {
        return {
          ...item,
          title: `${item.name}`,
          name: `${item.name}`,
          ownerName: item.owner?.displayName,
          value: item.id,
        };
      });

      state.list = formatData;

      state.isLoaded = true;
    });
  },
});

const { actions, reducer: entityCustomerGroupReducer } =
  entityCustomerGroupSlice;

export const {
  reloadEntityCustomerGroup,
  updateSavedListEntityCustomerGroup,
  updateSavedPaginationEntityCustomerGroup,
} = actions;

export default entityCustomerGroupReducer;
